import * as React from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../../actions";
import strings from "../../../helpers/Localization";

//CUSTOM COMPONENT
import Area from "../../../aGlobalDesign/Area/Area";
import PaginationList from "../../../aGlobalDesign/Pagination/PaginationList";
import ButtonSkaRound from "../../../aGlobalDesign/Buttons/ButtonSkaRound";
import Drawer from "../../../aGlobalDesign/Modal/Drawer";
import Inputs from "../../../aGlobalDesign/Inputs/Inputs";
import Toggle from "../../../aGlobalDesign/Inputs/Toggle";

class UserGroupsList extends React.Component {

    constructor() {
        super();
        this.state = {
            searchField: "",
            forcePaginationUpdate: 0,
            selectedUserGroup: null,
            temporaryElement: null
        };
    }

    componentDidMount() {
        this.props.changeAppBarTitle(strings.UserGroupsList);
        this.props.ChangeCurrentMenuName("UserGroupsList");
    }
    forcePaginationUpdate() {
        const temp = this.state.forcePaginationUpdate + 1;
        this.setState({
            selectedUserGroup: null,
            forcePaginationUpdate: temp
        });
    }
    componentDidUpdate(prevProps) {
        if (this.props.reload && this.props.reload !== prevProps.reload) {
            this.forcePaginationUpdate();
        }
        if (this.props.createNew !== prevProps.createNew) {
            this.OnLoadUserGroupClick(null);
        }
    }

    //#region functions
    OnLoadUserGroupClick(userGroup) {
        let ug = userGroup;
        if (ug === null) {
            ug = {
                id: 0,
                name: "",
                users: [],
                userGroupPermissions: this.props.currentuser.accessrights.permissions
            };
            ug.userGroupPermissions.forEach(p => {
                p.id === -1;
                if (p.allow > 0) {p.allow = 10;}
                if (p.consult > 0) {p.consult = 10;}
                if (p.create > 0) {p.create = 10;}
                if (p.delete > 0) {p.delete = 10;}
                if (p.modify > 0) {p.modify = 10;}
            });
        }
        const temp = this.CreateTemp(ug);
        this.setState({
            selectedUserGroup: ug,
            temporaryElement: temp
        });
    }
    CreateTemp(element) {
        const temp = {
            id: element.id,
            name: element.name,
            lockAccessRights: element.lockAccessRights,
            userGroupPermissions: element.userGroupPermissions
        };
        return temp;
    }
    SaveTemp(temp, element) {
        element.name = temp.name;
        element.lockAccessRights = temp.lockAccessRights;
        element.userGroupPermissions = temp.userGroupPermissions;
        return element;
    }
    OnSaveChangeUserGroup() {
        const changedUserGroup = this.state.selectedUserGroup;
        this.SaveTemp(this.state.temporaryElement, changedUserGroup);
        changedUserGroup.organizationId = this.props.currentuser.currentorganization.id;
        changedUserGroup.organization = null;
        changedUserGroup.contentGroups = null;
        changedUserGroup.permissions = null;

        if (changedUserGroup.users) {delete changedUserGroup.users;}

        if (changedUserGroup.id === 0) {
            //Create new user Group
            changedUserGroup.userGroupMemberships = [];

            //send to DB
            this.props.CreateUserGroup(changedUserGroup, (data) => {
                this.forcePaginationUpdate();
                this.props.GetSecondaryUserGroupsList((data) => {});
            });
        }
        else {
            //Save changes on DB
            this.props.EditUserGroup(changedUserGroup, (changedUserGroupTimestamp) => {
                this.forcePaginationUpdate();
                this.props.GetSecondaryUserGroupsList((data) => {});
            });
        }
    }

    GetPermissionTitle(id) {
        switch (id) {
            case 10 : return strings.dashboard;
            case 15 : return strings.callLog;
            case 20 : return strings.callLink;
            case 25 : return strings.CallLinkControlScreen;
            case 30 : return strings.CBPayment;
            case 40: return strings.ContentsList;
            case 50 : return strings.Zones;
            case 300 : return strings.Categories;
            case 60 : return strings.CallCenters;
            //case 65 : return "Centre d'appel ‣ Transfers possibles";
            case 70 : return strings.DecisionTrees;
            case 75 : return strings.DecisionTreeCallCenterAllotment;
            case 80 : return strings.PortalsAgent;
            case 85 : return strings.IntercomCallCenterAllotment;
            case 90 : return strings.PortalsClient;
            case 100 : return strings.UserGroups;
            case 200 : return strings.Users;
            case 210 : return strings.UserCallCenterAllotment;
            case 220 : return strings.UserIntercomAllotment;
            case 400 : return strings.URLCallsPermanent;
            case 410 : return strings.CallApp;
            case 420 : return strings.WaitingList;
            case 500 : return strings.Storage;
            case 600 : return strings.Messaging;
            case 430 : return strings.URLRecallClients;
            case 700 : return strings.Carousel;
            default: return "";
        }
    }
    GetPermissionAuthorizations() {
        return [
            { id: "allow", name: strings.Authorize },
            { id: "consult", name: strings.Consult },
            { id: "create", name: strings.Create },
            { id: "modify", name: strings.Modify },
            { id: "delete", name: strings.Delete }
        ];
    }
    //#endregion

    render() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;

        const restrictedPermission = [10, 15, 70, 75, 80, 85, 90, 100, 110, 120, 200, 210, 220, 300, 400, 410, 420, 600];
        const restrictedByZone = [10, 15, 70, 300, 90, 400];

        return <>
            <PaginationList
                forcePaginationUpdate={this.state.forcePaginationUpdate}

                onGetElements={this.props.GetUserGroupsList}
                onSavePagination={this.props.SaveUserGroupsPagination}
                myElements={this.props.administration.usergroups}

                tableElement={(element) => {
                    return [
                        {
                            colTitle: strings.SortName,
                            sortIndex: 0,
                            fixedWidth: "400px",
                            lockWidth: true,
                            colContent: element ? element.name : null
                        },
                        {
                            colTitle: strings.actions,
                            colType: "actions",
                            actions: [0, 1, 2],
                            colContent: [
                                <ButtonSkaRound
                                    key={"view"}
                                    type="primary"
                                    isDisabled={!accessrights || accessrights.hasPermission(100, "consult") <= 10 }
                                    nameIcon="eye"
                                    onClick={() => this.setState({ preview: element })}
                                />,
                                <ButtonSkaRound
                                    key={"edit"}
                                    type="primary"
                                    isDisabled={!accessrights || accessrights.hasPermission(100, "modify") <= 10 }
                                    nameIcon="edit"
                                    onClick={() => this.OnLoadUserGroupClick(element)}
                                />,
                                <ButtonSkaRound
                                    key={"trash"}
                                    isDisabled={!accessrights || accessrights.hasPermission(100, "delete") <= 10 || !element || !element.allowDelete ? true : false}
                                    type="primary"
                                    nameIcon="trash"
                                    onClick={() => {
                                        this.props.OpenDialog({
                                            title: strings.deleteConfirm,
                                            description: strings.textDeleteItem,
                                            secondaryLabel: strings.cancel,
                                            primaryLabel: strings.confirmDelete,
                                            onPrimaryAction: () => {
                                                this.props.DeleteUserGroup(element.id, () => this.forcePaginationUpdate());
                                            }
                                        });
                                    }}
                                />
                            ]
                        }
                    ];
                }}
            />
            <Drawer open={this.state.selectedUserGroup !== null}
                onClose={() => this.forcePaginationUpdate()}
                title={this.state.selectedUserGroup && this.state.selectedUserGroup.id !== 0 ? strings.userGroups + " / " + this.state.temporaryElement.name : strings.newUserGroup}
                validationIcon={"save"}
                validationTitle={strings.save}

                onValidate={ this.state.selectedUserGroup && this.state.selectedUserGroup.id === 0 || accessrights && accessrights.hasPermission(100, "modify") > 10 ? () => this.OnSaveChangeUserGroup() : null}
            >
                {
                    this.state.temporaryElement ?
                        <>
                            <div className="ContentTitle">{strings.Settings} </div>
                            <Inputs field={{
                                type: "textfield",
                                title: strings.name,
                                placeholder: strings.name,
                                error: this.state.temporaryElement.name === "",
                                value: this.state.temporaryElement.name,
                                onChange: (e) => {
                                    const dp = this.state.temporaryElement;
                                    dp.name = e.target.value;
                                    this.setState({ temporaryElement: dp });
                                }
                            }}/>
                            <Inputs field={{ type: "divider" }}/>
                            <div className="ContentTitle">{strings.permissions} </div>
                            {
                                this.state.temporaryElement.userGroupPermissions.map((ug, ugIndex) => {
                                    if (ug.permissionTypeId === 600 && (accessrights && !accessrights.orgLimitations.allowVideoMessages)) {
                                        return null;
                                    }
                                    if (ug.permissionTypeId === 30 && (accessrights && !accessrights.orgLimitations.allowRemotePayment)) {
                                        return null;
                                    }
                                    if (ug.permissionTypeId === 25 && (accessrights && !accessrights.orgLimitations.allowRemoteControl)) {
                                        return null;
                                    }

                                    const disabled = !accessrights || accessrights.hasPermission(100, "modify") <= 10 || this.state.temporaryElement.lockAccessRights;
                                    return <div key={ug.permissionTypeId} style={{
                                        alignSelf: "stretch", padding: "20px", display: "flex", flexDirection: "column", gap: "20px",
                                        borderRadius: "6px", background: "var(--grey-lighter)"
                                    }}>
                                        <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                            {this.GetPermissionTitle(ug.permissionTypeId)}
                                        </div>
                                        <Inputs field={{ type: "divider" }}/>
                                        {this.GetPermissionAuthorizations().map((pa) => {
                                            if (ug[pa.id] > 0) {
                                                const checked = ug[pa.id] > 10;
                                                const restictionTitle = restrictedByZone.includes(ug.permissionTypeId) ? strings.WithRestrictionOnOrigin : strings.WithCallCenterRestriction;
                                                return <div key={pa.id} style={{
                                                    display: "flex", flexDirection: "row", gap: "20px", alignItems: "center", minHeight: "24px"
                                                }}>
                                                    <div style={{ minWidth: "150px" }}>
                                                        <Toggle
                                                            type="switch"
                                                            disabled={disabled}
                                                            name={pa.name}
                                                            checked={checked}
                                                            onClick={() => {
                                                                const temp = this.state.temporaryElement;
                                                                if (checked) { temp.userGroupPermissions[ugIndex][pa.id] = 10; }
                                                                else {temp.userGroupPermissions[ugIndex][pa.id] = 30;}
                                                                this.setState({ temporaryElement: temp });
                                                            }}/>
                                                    </div>
                                                    {
                                                        restrictedPermission.includes(ug.permissionTypeId) && pa.id !== "delete" && pa.id !== "allow" && checked ? <>
                                                            <Toggle
                                                                type="check"
                                                                disabled={disabled}
                                                                name={restictionTitle}
                                                                checked={ug[pa.id] === 20}
                                                                onClick={() => {
                                                                    const temp = this.state.temporaryElement;
                                                                    if (ug[pa.id] === 20) { temp.userGroupPermissions[ugIndex][pa.id] = 30; }
                                                                    else {temp.userGroupPermissions[ugIndex][pa.id] = 20;}
                                                                    this.setState({ temporaryElement: temp });
                                                                }}/>
                                                        </> : null
                                                    }
                                                </div>;
                                            }
                                        })}
                                    </div>;
                                })
                            }
                        </> : null
                }
            </Drawer>
            <Drawer open={this.state.preview}
                onClose={() => this.setState({ preview: null })}
                title={strings.userGroups + " / " + (this.state.preview ? this.state.preview.name : "")}
            >
                {
                    this.state.preview ?
                        <>
                            <div className="ContentTitle">{strings.Settings} </div>
                            <Inputs field={{
                                type: "textfield",
                                title: strings.name,
                                placeholder: strings.name,
                                value: this.state.preview.name,
                                disabled: true,
                                onChange: (e) => {}
                            }}/>
                            <Inputs field={{ type: "divider" }}/>
                            <div className="ContentTitle">{strings.permissions} </div>
                            {
                                this.state.preview.userGroupPermissions.map((ug, ugIndex) => {
                                    const disabled = true;
                                    return <div key={ug.permissionTypeId} style={{
                                        alignSelf: "stretch", padding: "20px", display: "flex", flexDirection: "column", gap: "20px",
                                        borderRadius: "6px", background: "var(--grey-lighter)"
                                    }}>
                                        <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                            {this.GetPermissionTitle(ug.permissionTypeId)}
                                        </div>
                                        <Inputs field={{ type: "divider" }}/>
                                        {this.GetPermissionAuthorizations().map((pa) => {
                                            if (ug[pa.id].permissionTypeId === 600 && (accessrights && !accessrights.orgLimitations.allowVideoMessages)) {
                                                return null;
                                            }
                                            if (ug[pa.id].permissionTypeId === 30 && (accessrights && !accessrights.orgLimitations.allowRemotePayment)) {
                                                return null;
                                            }
                                            if (ug[pa.id].permissionTypeId === 25 && (accessrights && !accessrights.orgLimitations.AllowRemoteControl)) {
                                                return null;
                                            }
                                            if (ug[pa.id] > 0) {
                                                const checked = ug[pa.id] > 10;
                                                const restictionTitle = restrictedByZone.includes(ug.permissionTypeId) ? strings.WithZoneRestriction : strings.WithCallCenterRestriction;
                                                return <div key={pa.id} style={{
                                                    display: "flex", flexDirection: "row", gap: "20px", alignItems: "center", minHeight: "24px"
                                                }}>
                                                    <div style={{ minWidth: "150px" }}>
                                                        <Toggle
                                                            type="switch"
                                                            disabled={disabled}
                                                            name={pa.name}
                                                            checked={checked}
                                                            onClick={() => { }}/>
                                                    </div>
                                                    {
                                                        restrictedPermission.includes(ug.permissionTypeId) && pa.id !== "delete" && pa.id !== "allow" && checked ? <>
                                                            <Toggle
                                                                type="check"
                                                                disabled={disabled}
                                                                name={restictionTitle}
                                                                checked={ug[pa.id] === 20}
                                                                onClick={() => {}}/>
                                                        </> : null
                                                    }
                                                </div>;
                                            }
                                        })}
                                    </div>;
                                })
                            }
                        </> : null
                }
            </Drawer>
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default withRouter(connect(
    (state) => state,
    mapDispatchToProps
)(UserGroupsList));
